import { Card, CardContent, Grid, Popover } from "@mui/material";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";
import Skelet from "../Skelet";
import React from "react";
import {Link} from "react-router-dom";

function QrCode(props) {
  const { uid } = props;
  let urlProfile = new URL(window.location.href);
  urlProfile.searchParams.set("id", uid);
  let urlLink = new URL(window.location.href + "login");
  urlLink.searchParams.set("id", uid);
  let data = <Skelet />;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const renderQR = (url) => {
    return <QRCode value={url} />;
  };

  try {
    if (uid !== undefined) {
      data = renderQR(urlProfile.href);
    }
  } catch {}

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography sx={{ fontSize: 25 }} fontFamily="Mossport" color="text.secondary" gutterBottom>
          QR-КОД
        </Typography>
        <Grid justifyContent="center" container>
          {data}
        </Grid>
        <Grid mt={2} justifyContent="center" container>

          <Typography><Link to={urlLink} >Cсылка-приглашение</Link></Typography>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 1 }}>Приглашение скопировано</Typography>
          </Popover>
        </Grid>
      </CardContent>
    </Card>
  );
}

QrCode.propTypes = {
  uid: PropTypes.any,
};

export default QrCode;
